import { render, staticRenderFns } from "./exploracao.vue?vue&type=template&id=2e8c2008&scoped=true&"
import script from "./exploracao.vue?vue&type=script&lang=js&"
export * from "./exploracao.vue?vue&type=script&lang=js&"
import style0 from "./exploracao.vue?vue&type=style&index=0&id=2e8c2008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c2008",
  null
  
)

export default component.exports